import React from 'react'
import { Search as SearchIcon } from 'react-feather'

import {
  Card,
  Typography,
  Box,
  makeStyles,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@material-ui/core'
import { ListOrganizations } from '../'

import styles from './styles'

const useStyles = makeStyles(styles)

const CardOrganizations = ({
  usersOrganizations,
  isLoading,
  onLoadMore,
  searchInput,
  onSearch,
}) => {
  const classes = useStyles()

  return (
    <>
      <Box mb={2} className={classes.wrapper}>
        <Box mb={2}>
          <Typography variant="h4">Selecione o grupo advisor</Typography>
        </Box>

        <Card className={classes.root}>
          <Box mx={2} mt={2}>
            <TextField
              fullWidth
              placeholder="Pesquise pelo nome da organização"
              value={searchInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon size={20} />
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              onChange={(e) => onSearch(e.target.value)}
            />
          </Box>
          <Box mt={2}>
            {isLoading && usersOrganizations.length === 0 && (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            )}
            {usersOrganizations.length > 0 && (
              <ListOrganizations
                usersOrganizations={usersOrganizations}
                onLoadMore={onLoadMore}
                isLoadingMore={isLoading}
              />
            )}
          </Box>
        </Card>
      </Box>
    </>
  )
}

export default CardOrganizations
